import {getCurrentSitePlease} from 'redux/modules/currentUser/actions'
import {getCurrentSite} from 'redux/modules/currentUser/selectors'
import {getMerchantBySite} from 'redux/modules/sites/selectors'
import {getChannelIntegrations} from './selectors'
import {CALL_API, Call} from 'redux/middleware/api'
import {reportError} from 'redux/modules/error/actions'
import formatDateWithTz from 'utils/formatDateWithTz'

import {
  INTEGRATIONS_CHANNEL_COSTS,
  INTEGRATIONS,
  INTEGRATIONS_ADD,
  INTEGRATIONS_REMOVE,
  INTEGRATIONS_MARK_AS_CONNECTED,
  INTEGRATION_DETAILS
} from './index'

const statsVersion = localStorage.getItem('statsVersion') === 'v1' ? '' : 'v2/'

export function addIntegration(serviceId, options) {
  return (dispatch, getState) => {
    const state = getState()
    const {id: merchantSiteId} = getCurrentSite(state)
    const merchant = getMerchantBySite(state, merchantSiteId)

    return dispatch({
      [CALL_API]: {
        endpoint: `merchants/${merchant.id}/integrations/${serviceId}`,
        errorsHandled: true,
        method: 'POST',
        types: INTEGRATIONS_ADD,
        queryParams: options.password ? {} : options,
        body: options.password ? options : {}
      }
    })
  }
}

export function fetchIntegrations() {
  return (dispatch, getState) => new Call((success, fail) => {
    return getCurrentSitePlease(dispatch, getState)
      .success(() => {
        const state = getState()
        const {id: merchantSiteId} = getCurrentSite(state) || {}
        if (!merchantSiteId) return success(null)
        const merchant = getMerchantBySite(state, merchantSiteId)

        if (!merchant) return success(null)
        const {id: merchantId} = merchant

        return dispatch({
          [CALL_API]: {
            endpoint: `merchants/${merchantId}/integrations`,
            errorsHandled: true,
            types: INTEGRATIONS,
            queryParams: {
              merchantSiteId
            }
          }
        })
          .success(success)
          .fail(fail)
      })
  })
}

export function fetchIntegrationCosts(integrationId, startDate, endDate, timezone) {
  return (dispatch, getState) => {
    const {id: merchantSiteId} = getCurrentSite(getState())
    return dispatch({
      [CALL_API]: {
        endpoint: `${statsVersion}stats`,
        types: INTEGRATIONS_CHANNEL_COSTS,
        queryParams: {
          merchantSiteId,
          metrics: 'cost:total',
          'filter[integration]': integrationId,
          'range[start]': formatDateWithTz(startDate),
          'range[end]': formatDateWithTz(endDate),
          timeUnit: 'day',
          timezone
        }
      }
    }).fail(dispatch(reportError()))
  }
}

export function fetchIntegrationInfo(integrationId, channelGroup, channel) {
  return (dispatch, getState) => {
    const state = getState()
    const integrations = getChannelIntegrations(state, channelGroup, channel)
    const {id: merchantSiteId} = getCurrentSite(state)
    const merchant = getMerchantBySite(state, merchantSiteId)
    const integration = integrations.find(i => i.id === integrationId)
    const {id, serviceId, api} = integration || {}

    if (serviceId === 'google-spreadsheet') {
      dispatch({
        [CALL_API]: {
          endpoint: `merchants/${merchant.id}/integrations/google-spreadsheet/${id}/spreadsheet`,
          types: INTEGRATION_DETAILS,
          queryParams: {integrationId: id}
        }
      })
    } else if (api) {
      dispatch({
        [CALL_API]: {
          endpoint: `merchants/${merchant.id}/integrations/${serviceId}/${id}/accounts`,
          types: INTEGRATION_DETAILS,
          queryParams: {integrationId: id}
        }
      })
    }
  }
}

export function disconnectIntegration(serviceId, integrationId) {
  return (dispatch, getState) => {
    const state = getState()
    const {id: merchantSiteId} = getCurrentSite(state)
    const merchant = getMerchantBySite(state, merchantSiteId)
    return dispatch({
      [CALL_API]: {
        endpoint: `merchants/${merchant.id}/integrations/${serviceId}/${integrationId}`,
        method: 'DELETE',
        types: INTEGRATIONS_REMOVE
      }
    })
      .success(() => {
        dispatch(fetchIntegrations())
      })
      .fail(dispatch(reportError()))
  }
}

export function markAsConnected(serviceId) {
  return {
    type: INTEGRATIONS_MARK_AS_CONNECTED,
    serviceId
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/integrations/actions.js